// 越南语
export default {
  'SLModal.default.okText': 'Hoàn thành',
  'SLModal.default.cacelText': 'Hủy',
  'SLModal.info.okText': 'Tôi đã hiểu',
  'SLPopconfirm.cancelText': 'Hủy',
  'SLPopconfirm.okText': 'Ok',
  'SLModal.danger.okText': 'Xóa',
  'SLUpload.default.image.addImage': 'Thêm một hình ảnh',
  'SLUpload.default.image.restImages': 'Xem ảnh {{len}} còn lại',
  'SLUpload.default.image.loading': 'Đang tải lên…',
  'SLUpload.default.image.fail': 'Tải lên không thành công, vui lòng thử lại',
  'SLUpload.default.image.delete.title': 'Bạn có chắc chắn muốn xóa?',
  'SLUpload.default.image.delete.content': 'Không thể khôi phục sau khi xóa.',
  'SLUpload.ALTFormModal.placeholder': 'Vui lòng nhập thuộc tính ALT của ảnh',
  'SLUpload.ALTFormModal.tip': 'Chỉnh sửa các thuộc tính ALT của hình ảnh giúp tối ưu hóa công cụ tìm kiếm (SEO) và trải nghiệm người khiếm thị',
  'SLUpload.ALTFormModal.title': 'Biên tập thuộc tính ALT của ảnh',
  'SLUpload.ALTFormModal.length': 'Không được vượt quá {{max}} ký tự',
  'SLUpload.uploadfile.fail': 'Tải lên lỗi',
  'SLUpload.uploadfile.fail1': 'Lỗi định dạng tệp',
  'SLUpload.uploadfile.sucess': 'Tải lên thành công',
  'SLUpload.uploadfile.text1': 'Tải lên tệp',
  'SLUpload.uploadfile.text2': '',
  'SLUpload.uploadfile.progress': 'Đang tải lên ..',
  'SLUpload.dragUploading': 'Thả chuột là tải lên',
  'SLUpload.default.image.description': 'Kích thước đề xuất 256 x 116',
  'SLUpload.default.image.fail.title': '{{fileName}} không tải lên được',
  'SLUpload.default.image.fail.desc1': 'Kích thước không được vượt quá {{max}} MB',
  'SLUpload.default.image.fail.desc2': 'Tên tải lên không được vượt quá {{max}} ký tự',
  'SLUpload.default.image.fail.desc3': 'Tập tin đã vượt quá độ phân giải tối đa{{limitPx}}MP. Xin vui lòng giảm độ phân giải và thử lại',
  'SLUpload.default.image.fail.desc4': 'Xin lỗi! Chỉ được tải lên tối đa {{maxNum}} ảnh!',
  'SLUpload.uploadField.errorMsg4': 'Tải ảnh lên lỗi',
  'SLUpload.uploadField.upload': 'Tải ảnh lên',
  'SLUpload.SLImage.preview.closeText': 'Tắt'
};